(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('FixationPricingDialogController', FixationPricingDialogController);

    FixationPricingDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'MiscService', 'ToastrService', 'Fixation'];

    function FixationPricingDialogController($timeout, $scope, $uibModalInstance, entity, MiscService, ToastrService, Fixation) {
        var vm = this;

        vm.fixation = entity;
        vm.isSaving = false;
        vm.pricingYears = MiscService.returnPricingYears();

        vm.clear = clear;
        vm.save = save;
        vm.onPriceChange = onPriceChange;
        vm.onTextClick = onTextClick;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            vm.fixation.contract = {
                id: vm.fixation.contract.id
            };
            if (vm.fixation.id && vm.fixation.id !== null && vm.fixation.id > 0) {
                Fixation.update(vm.fixation, onSaveSuccess, onSaveError);
            } else {
                Fixation.save(vm.fixation, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('ccsTrApp:fixationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            ToastrService.success("Successfully saved Fixation", "Success!");
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function onPriceChange() {
            if (vm.fixation.pricing.onOff === "OFF") {
                vm.fixation.finalPriceFixationAmount = vm.fixation.futurePrice - vm.fixation.pricing.price;
                vm.fixation.interCompPrice = vm.fixation.futurePrice - vm.fixation.pricing.icPrice;
            } else {
                vm.fixation.finalPriceFixationAmount = vm.fixation.futurePrice + vm.fixation.pricing.price;
                vm.fixation.interCompPrice = vm.fixation.futurePrice + vm.fixation.pricing.icPrice;
            }
        }

        function onTextClick($event) {
            $event.target.select();
        }
    }
})();
